<nav class="navbar navbar-expand-lg navbar-dark bg-dark p-0 sales-manager-nav">
    <div class="container-fluid">
        <div class="navbar-header">
            <a class="navbar-brand" [routerLink]="['/admin/parker-crm/table']"> <i class="fa-solid fa-address-book"></i> Parker CRM </a>
        </div>

        <button
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            class="navbar-toggler d-block d-md-none"
            data-bs-target="#navbarSupportedContent"
            data-bs-toggle="collapse"
            type="button"
        >
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a [routerLink]="['/admin/parker-crm/users']" class="nav-link" routerLinkActive="active"> <i class="fa-solid fa-users"></i> Users </a>
                </li>
                <li class="nav-item">
                    <a [routerLink]="['/admin/parker-crm/board']" class="nav-link" routerLinkActive="active"> <i class="fa-solid fa-columns"></i> Board </a>
                </li>
                <li class="nav-item">
                    <a [routerLink]="['/admin/parker-crm/table']" class="nav-link" routerLinkActive="active"> <i class="fa-solid fa-table"></i> Table </a>
                </li>
                <li class="nav-item">
                    <a [routerLink]="['/admin/parker-crm/stats']" class="nav-link" routerLinkActive="active"> <i class="fa-solid fa-chart-bar"></i> Stats </a>
                </li>
            </ul>

            <ul class="navbar-nav ms-auto">
                <li class="nav-item dropdown">
                    <a aria-expanded="false" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button">
                        <i class="fa-solid fa-user-circle"></i>
                        {{ authService.email || 'Account' }}
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                            <a (click)="signOut()" class="dropdown-item" href="#"> <i class="fa-solid fa-sign-out-alt"></i> Logout </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>

<!-- Context Menu (needed for CRM functionality) -->
<div
    class="context-menu"
    id="context-menu"
    *ngIf="globalService.contextMenuVisible"
    [style.left.px]="globalService.contextMenuX"
    [style.top.px]="globalService.contextMenuY"
    (mouseenter)="globalService.cancelContextMenuHide()"
    (mouseleave)="globalService.hideContextMenuDelayed(200)"
>
    <ul class="context-menu-list">
        <li
            class="context-menu-item"
            [class.context-menu-item--has-submenu]="item.subMenuItems?.length"
            [class.context-menu-item--header]="item.isHeader"
            *ngFor="let item of globalService.contextMenuItems"
            (click)="!item.subMenuItems?.length && !item.isHeader && item.action(); globalService.hideContextMenu()"
        >
            <a><i *ngIf="item.icon" [class]="item.icon"></i> {{ item.label }}</a>
            <ul *ngIf="item.subMenuItems?.length" class="context-submenu-list">
                <li class="context-submenu-item" *ngFor="let subItem of item.subMenuItems" (click)="subItem.action(); globalService.hideContextMenu(); $event.stopPropagation()">
                    <a><i *ngIf="subItem.icon" [class]="subItem.icon"></i> {{ subItem.label }}</a>
                </li>
            </ul>
        </li>
    </ul>
</div>
